import { Route, Switch } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";
import { NavBar, Footer, Loading } from "./components";
import { PLC, Home, Profile, TermsConditions, PrivacyPolicy, Deserves, Products, MyProducts, SingleProductView, AddEditProduct, Admin, AdminUserEdit, AdminProductEdit, AdminDeserveEdit, Voucher, CompanyReview } from "./views";
import ProtectedRoute from "./auth/protected-route";
import Unauthorized from "./auth/unauthorized";
import CookieConsent from 'react-cookie-consent';

const App = () => {
  const { isLoading } = useAuth0();

  // Check if the myCookieConsent exists and is true
  const cookieConsent = Cookies.get('myCookieConsent') === 'true';

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <div className="container flex-grow-1">
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/terms-conditions" component={TermsConditions} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/unauthorized" component={Unauthorized} />

          {/* Only allow access to protected routes if cookieConsent is true */}
          {cookieConsent && (
            <>
              <Route exact path="/products" component={Products} />
              <Route exact path="/products/:companyName" component={Products} />
              <ProtectedRoute path="/profile" component={Profile} />
              <ProtectedRoute allowedRoles={["deserver"]} path="/deserves" component={Deserves} />
              <ProtectedRoute allowedRoles={["company"]} path="/allMyProducts" component={MyProducts} />
              <ProtectedRoute allowedRoles={["company"]} path="/singleProductView/:idProduct" component={SingleProductView} />
              <ProtectedRoute allowedRoles={["company"]} exact path="/addEditProduct" component={AddEditProduct} />
              <ProtectedRoute allowedRoles={["company"]} exact path="/addEditProduct/:idProduct" component={AddEditProduct} />
              <ProtectedRoute allowedRoles={["admin"]} exact path="/admin" component={Admin} />
              <ProtectedRoute allowedRoles={["admin"]} exact path="/adminProductEdit/:idProduct" component={AdminProductEdit} />
              <ProtectedRoute allowedRoles={["admin"]} exact path="/adminUserEdit/:idUser" component={AdminUserEdit} />
              <ProtectedRoute allowedRoles={["admin"]} exact path="/adminDeserveEdit/:idProduct/:idUser" component={AdminDeserveEdit} />
              <ProtectedRoute allowedRoles={["admin", "deserver", "company"]} exact path="/voucher/:voucherCode" component={Voucher} />
              <ProtectedRoute allowedRoles={["admin", "company"]} exact path="/companyReview/:idProduct/:idUser" component={CompanyReview} />
            </>
          )}

          {/* Else */}
          {!cookieConsent && (
            <>
              <ProtectedRoute path="/profile" component={PLC} />
              <ProtectedRoute path="/deserves" component={PLC} />
              <Route exact path="/products" component={PLC} />
              <Route exact path="/products/:companyName" component={PLC} />
              <ProtectedRoute path="/allMyProducts" component={PLC} />
              <ProtectedRoute path="/singleProductView/:idProduct" component={PLC} />
              <ProtectedRoute exact path="/addEditProduct" component={PLC} />
              <ProtectedRoute exact path="/addEditProduct/:idProduct" component={PLC} />
              <ProtectedRoute path="/admin" component={PLC} />
              <ProtectedRoute exact path="/adminProductEdit/:idProduct" component={PLC} />
              <ProtectedRoute exact path="/adminUserEdit/:idUser" component={PLC} />
              <ProtectedRoute exact path="/adminDeserveEdit/:idProduct/:idUser" component={PLC} />
              <ProtectedRoute exact path="/voucher/:voucherCode" component={PLC} />
              <ProtectedRoute exact path="/companyReview/:idProduct/:idUser" component={PLC} />
            </>
          )}
        </Switch>
      </div>
      {/* Cookie Consent Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Notwendige Cookies akzeptieren"
        declineButtonText="Alle Cookies ablehnen"
        enableDeclineButton // stellt sicher, dass der Ablehnen-Button angezeigt wird
        cookieName="myCookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{
          background: "#ECBB5C",
          color: "#4e503b",
          fontSize: "13px",
          borderRadius: "5px",
        }}
        declineButtonStyle={{
          background: "#ECBB5C",
          color: "#4e503b",
          fontSize: "13px",
          borderRadius: "5px",
          marginLeft: "10px",
        }}
        expires={150}
        onAccept={() => {
          // Reload the page when the user accepts cookies
          window.location.reload();
        }}
      >
        Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.
        Weitere Informationen findest Du in unseren
        <a href="/privacy-policy" style={{ color: "#ECBB5C" }}> Datenschutzerklärung</a>
      </CookieConsent>
      <Footer />
    </div>
  );
};

export default App;
